<template>
  <draggable
    v-if="graphic_fields[element.id] && graphic_fields[element.id].entries"
    animation="200"
    class="slides"
    v-bind="{ handle : '.drag-handle' }"
    v-model="graphic_fields[element.id].entries"
    revert-on-spill="true"
    :data-test="`graphics-editor-layer-droparea-${element.id}`"
  >
    <slide-layer
      v-for="(entry, ind) in graphic_fields[element.id].entries"
      :key="ind"
      :element="element"
      :index="ind"
      :entry="entry"
      :selected="selected"
      :graphic_fields="graphic_fields"
      :data-test="`graphics-editor-layers-${element.id}-${ind}`"
      @select="select"
    />
  </draggable>
</template>

<script>
import { cloneDeep, pick, merge } from 'lodash-es';
import draggable from 'vuedraggable';

import getDefaultFields from '../../../utils/graphics-fields';
import SlideLayerComponent from './SlideLayer.vue';
import { entriesMap } from '../../../utils/graphics-utils';

const { v1: uuidv1 } = require('uuid');

export default {
  props: ['selected', 'graphic_fields', 'element'],

  components: {
    'slide-layer': SlideLayerComponent,
    draggable,
  },

  created() {
    const { element } = this;

    const elDefaults = getDefaultFields(element.type);
    const defaultKeys = Object.keys(elDefaults);
    const mergedDefaults = merge({}, elDefaults, pick(element, defaultKeys));

    if (!this.graphic_fields[element.id] || !this.graphic_fields[element.id].entries) {
      // Initialize fields w/entries array
      this.$set(this.graphic_fields, element.id, {
        visible: true,
        ...mergedDefaults,
        entries: [{
          fields: entriesMap(element.elements, getDefaultFields(element.type)),
          meta: {
            name: 'Slide 1',
            collapsed: false,
            visible: true,
          },
        }],
      });
    }

    this.graphic_fields[element.id].entries.forEach((entry, index) => {
      const entryLookup = [];

      // Set element fields from graphic entries
      const setFields = (elements) => {
        elements.forEach((el) => {
          // eslint-disable-next-line no-param-reassign
          el = { ...getDefaultFields(el.type), ...el };

          entryLookup[index] = entryLookup[index] || {};
          entryLookup[index][el.template_id] = JSON.parse(JSON.stringify(el));

          if (el.entries) {
            setFields(el.entries);
          }
        });
      };

      // Set fields based on graphics defaults/add missing
      const resetOverrides = (els) => {
        const elements = els;

        elements.forEach((el, ind) => {
          if (entryLookup[index][el.id]) {
            // Set up elements
            elements[ind] = cloneDeep(entryLookup[index][el.id]);

            let withEntries; // Contains entries?

            if (el.entries) {
              withEntries = pick(el, 'entries');
            }

            if (withEntries) {
              elements[ind].entries = withEntries.entries;
            }
          } else {
            const keys = Object.keys(getDefaultFields(el.type));
            const id = uuidv1();

            keys.push('name', 'type', 'editable');

            const obj = pick(el, keys);

            obj.template_id = el.id;
            obj.id = id;
            obj.visible = true;
            this.graphic_fields[id] = obj;
            elements[ind] = cloneDeep(obj);
          }

          if (el.entries) {
            resetOverrides(el.entries);
          }
        });
      };

      setFields(this.graphic_fields[element.id].entries[index].fields);
      this.graphic_fields[element.id].entries[index].fields = cloneDeep(this.element.elements);

      this.graphic_fields[element.id].entries[index].fields.forEach((el, ind) => {
        if (el.entries) {
          this.graphic_fields[element.id].entries[index].fields[ind].entries = (
            cloneDeep(this.element.elements[ind].elements)
          );
        }
      });

      resetOverrides(this.graphic_fields[element.id].entries[index].fields);
      this.graphic_fields[element.id].entries[index].fields = (
        cloneDeep(this.graphic_fields[element.id].entries[index].fields)
      );
    });
  },

  computed: {
    entries: {
      get() {
        return this.elementFields?.entries;
      },

      set(val) {
        this.$set(this.graphic_fields[this.element.id], 'entries', val);
      },
    },
  },

  methods: {
    select(element) {
      if (element.type !== 'group') {
        this.$emit('select', element);
      }
    },
  },
};
</script>
